import React, { useState, useContext, useMemo } from 'react'
import withConfig from '../../wrappers/withConfig'
import dayjs from 'dayjs'
import { FaInfoCircle } from 'react-icons/fa'
import NotesModal from '../../features/processPage/Notes/NotesModal'
import ActionSelect from '../../features/processPage/Actions/ActionSelect'
import { CurrentProcessContext } from '../../wrappers/CurrentProcessContext'
import DateEditCell from '../../features/processPage/Grid/DateEditCell'

const format = 'MM/DD/YYYY'
const dateToString = (date) =>
    date ? dayjs(date).format(format).toString() : null

const Cell = ({ value, type, column, row }) => {
    return column === 'DueDate' ? (
        <DateEditCell value={value} row={row} column={column} />
    ) : (
        <div className="tableCell">
            {type === 'Date' && value
                ? dateToString(value)
                : type === 'String' && value && value.includes('<br/>')
                ? value.split('<br/>').map((line) => <div>{line}</div>)
                : value}
        </div>
    )
}

const NoteCell = ({ id }) => <NotesModal id={id} />

const ActionCell = ({ maxDuration, stateId, externalDataItemId, row }) => {
    const { transitions } = useContext(CurrentProcessContext)
    const options = transitions.filter(
        (transition) => transition.CurrentStateId === Number(stateId)
    )
    return (
        <ActionSelect
            options={options.length ? options : null}
            stateId={stateId}
            maxDuration={maxDuration}
            item={row.original}
        />
    )
}

const InfoCell = ({ attributes, id }) => {
    const [popUp, setPopUp] = useState(false)

    const { process } = useContext(CurrentProcessContext)
    const rows = useMemo(
        () => (process ? Object.keys(process.ProcessTooltipColumns) : []),
        [process]
    )
    const exampleTooltip = useMemo(
        () => (process ? process.ProcessTooltipColumns : {}),
        [process]
    )

    if (!Object.keys(attributes).length) {
        return null
    }

    const handleMouseEnter = () => {
        setPopUp(true)
    }
    const handleMouseLeave = () => {
        setPopUp(false)
    }

    return (
        <>
            <div
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
            >
                <FaInfoCircle style={{ cursor: 'pointer' }} />
                <div className={!popUp ? 'hidden' : 'connect'}></div>
                <div className={!popUp ? 'hidden' : 'popUp box'}>
                    <ul className="tooltip-list">
                        {rows.map((key, index) => {
                            if (attributes[key]) {
                                if (
                                    exampleTooltip[key].DataType === 'Hyperlink'
                                ) {
                                    return (
                                        <li
                                            key={`tooltip-${index}`}
                                            className="tooltip-list-item has-text-7"
                                        >
                                            <label
                                                style={{
                                                    marginBottom:
                                                        '0% !important',
                                                }}
                                            >
                                                {`${exampleTooltip[key].Label}: `}
                                            </label>
                                            <a
                                                rel="noreferrer"
                                                target="_blank"
                                                href={attributes[key]}
                                            >
                                                {attributes[key].slice(8, 31)}
                                            </a>
                                        </li>
                                    )
                                }
                                return (
                                    <li
                                        key={`tooltip-${index}`}
                                        className="tooltip-list-item has-text-7"
                                    >
                                        <label>
                                            {`${exampleTooltip[key].Label}: `}
                                        </label>
                                        <span className="info">
                                            {attributes[key]}
                                        </span>
                                    </li>
                                )
                            }
                        })}
                    </ul>
                </div>
            </div>
        </>
    )
}

export { Cell, NoteCell, ActionCell, InfoCell }
export default withConfig(DateEditCell)
